import React, { useId } from 'react';
import { Search } from 'lucide-react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
}
export function Input({
  label,
  error,
  icon,
  className = '',
  fullWidth = true,
  id,
  ...props
}: InputProps) {
  const inputId = id || useId();
  return <div className={`${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-222">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-223">
          {label}
        </label>}
      <div className="relative" data-id="element-224">
        {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400" data-id="element-225">
            {icon}
          </div>}
        <input id={inputId} className={`
            flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm placeholder:text-slate-400 
            focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50
            ${icon ? 'pl-10' : ''}
            ${error ? 'border-red-500 focus:ring-red-500' : ''}
          `} {...props} data-id="element-226" />
      </div>
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-227">{error}</p>}
    </div>;
}